import React, { useEffect } from "react";

import { useTheme } from "styled-components";

import Icon from "../../../../../../../../../components/ui/icon/Icon";
import { Tab, TabsContainer } from "./styles";

const Rounded = ({
  data,
  tab: { selectedTab, setSelectedTab },
  mode,
  macroId,
}) => {
  useEffect(() => {
    if (mode === "view") {
      window.AP.cookie.read(`caelor-optics-nested-tabs-${macroId}`, (value) => {
        if (value) {
          setSelectedTab(value);
        }
      });
    }
  }, [selectedTab]);

  useEffect(() => {
    if (mode !== "view") {
      setSelectedTab(data.tabs[0].value);
    }
  }, [data.tabs]);

  const theme = useTheme();

  return (
    <TabsContainer>
      {data.tabs.map((tab) => (
        <Tab
          key={tab.value}
          textColor={data.colors.text[theme.name]}
          accentColor={data.colors.accent[theme.name]}
          isActive={selectedTab === tab.value}
          onClick={() => {
            setSelectedTab(tab.value);

            if (mode === "view") {
              window.AP.cookie.save(
                `caelor-optics-nested-tabs-${macroId}`,
                tab.value
              );
            }
          }}
        >
          {tab.icon && <Icon icon={tab.icon} size="18px" />}
          {tab.label}
        </Tab>
      ))}
    </TabsContainer>
  );
};

export default Rounded;
